<div class="alert-content" mat-dialog-content>
    <div class="red-alert-title" i18n="Royalty|Delete Confirm dialog|header">Delete specification?</div>
    <p i18n="Royalty|Delete confirm dialog|confirmation text">Do you want to delete this specification?</p>
</div>
<mat-dialog-actions class="red-alert-actions">
    <button mat-button color="primary" tabindex="-1" (click)="cancel()" i18n="Cancel button label">Cancel</button>
    <button mat-button color="primary" tabindex="-1" (click)="confirm()" i18n="Delete button label">Delete</button>
</mat-dialog-actions>
